<script>
export default {
    name: "ApiLogs",
    props: {
        modalTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            tableData: [],
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("api-log-modal");
        },
        async getData(id, planning) {
            this.tableBusy = true;
            try{
                if(planning){
                    const { data: res } = await this.$store.dispatch("planningapi/PlanningApiLogs", id);
                    if(res.error){
                        this.showToast(res.errorMessage, "error");
                        return;
                    }
                    res.forEach((item) => {
                        item.dateWTime = this.formatDateWithTime(
                            new Date(item.logDate)
                        );
                        item.splitted = item.dateWTime.split(" at ");
                    });
                    this.tableData = res.sort((a, b) => new Date(b.logDate) - new Date(a.logDate));
                }else{
                    const { data: res } = await this.$store.dispatch("api/GetApiLogs", id);
                    if(res.error){
                        this.showToast(res.errorMessage, "error");
                        return;
                    }
                    res.forEach((item) => {
                        item.dateWTime = this.formatDateWithTime(
                            new Date(item.logDate)
                        );
                        item.splitted = item.dateWTime.split(" at ");
                    });
                    this.tableData = res.sort((a, b) => new Date(b.logDate) - new Date(a.logDate))
                }
            }catch(e){
                console.log(e)
                this.showToast("Something went wrong!", "error");
            }
        },
        hasStatus(item, status) {
            return item.logType?.toLowerCase().includes(status);
        },
    },
};
</script>

<template>
    <b-modal
        id="api-log-modal"
        title="API Logs"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="d-flex justify-content-center">
            <ul class="verti-timeline list-unstyled">
                <li class="event-list" v-for="(x, xIndex) in tableData" :key="x.id" :class="{'active': xIndex == 0}">
                    <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle font-size-18" :class="{'bx-fade-right': xIndex == 0}"></i>
                    </div>
                    <div class="media">
                        <div class="me-3">
                            <h5 class="font-size-14 mb-0">
                                {{x.splitted[0]}}
                                <i
                                    class="
                                        bx bx-right-arrow-alt
                                        font-size-16
                                        text-primary
                                        align-middle
                                        ms-2
                                    "
                                ></i>
                            </h5>
                            <small>{{x.splitted[1]}}</small>
                        </div>
                        <div class="media-body">
                            <div class="mb-0" style="line-height:14px;">{{x.remarks}}</div>
                            <div class="badge bg-warning bg-soft px-1 rounded text-warning font-weight-bold" v-if="hasStatus(x, 'return')">
                                {{ x.logType }}
                            </div>
                            <div class="badge bg-success bg-soft px-1 rounded text-green font-weight-bold" v-if="hasStatus(x, 'approve')">
                                {{ x.logType }}
                            </div>
                            <div><small>({{x.loggedBy.trim()}})</small></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </b-modal>
</template>